import {Component} from '@angular/core';

@Component({
  selector: 'app-credit-resume-icon',
  templateUrl: './credit-resume-icon.component.html'
})
export class CreditResumeIconComponent {
}
